/* GateRedirect — quando o Gate de Lançamento está ativo, redireciona
 * usuários anônimos das rotas /login e /register para "/" (Gate).
 * Usuários autenticados passam normalmente.
 */
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

export default function GateRedirect({ children }) {
  const { user, loading } = useAuth();
  const [gate, setGate] = useState({ loading: true, enabled: false });

  useEffect(() => {
    let mounted = true;
    api.get("/config/public-gate")
      .then(({ data }) => mounted && setGate({ loading: false, enabled: !!data?.enabled }))
      .catch(() => mounted && setGate({ loading: false, enabled: false }));
    return () => { mounted = false; };
  }, []);

  if (gate.loading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-2 h-2 bg-[#0F1B2D] rounded-full animate-pulse" />
      </div>
    );
  }
  // Gate ativo + anônimo → joga para o Gate (rota raiz)
  if (gate.enabled && !user) return <Navigate to="/" replace />;
  return children;
}
